import type { SVGProps } from 'react'
const SvgSyGiftLight = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M5 8h14v8c0 1.886 0 2.828-.586 3.414S16.886 20 15 20H9c-1.886 0-2.828 0-3.414-.586S5 17.886 5 16z"
		/>
		<path d="M9.123 3C7.413 3 6 4.392 6 6.105c0 1.038.52 2.009 1.383 2.584l1.84 1.227a.5.5 0 0 0 .693-.139.5.5 0 0 0-.139-.693l-1.84-1.227A2.1 2.1 0 0 1 7 6.105C7 4.941 7.954 4 9.123 4c1.094 0 2.02.82 2.14 1.902l.24 2.153a.5.5 0 0 0 .552.441.5.5 0 0 0 .441-.55l-.238-2.155A3.157 3.157 0 0 0 9.123 3" />
		<path d="M14.877 3c-1.595 0-2.958 1.202-3.135 2.791l-.238 2.154a.5.5 0 0 0 .441.551.5.5 0 0 0 .551-.441l.24-2.153A2.15 2.15 0 0 1 14.877 4C16.046 4 17 4.94 17 6.105c0 .705-.351 1.362-.937 1.752l-1.84 1.227a.5.5 0 0 0-.139.693.5.5 0 0 0 .693.139l1.84-1.227A3.1 3.1 0 0 0 18 6.105C18 4.392 16.586 3 14.877 3" />
		<rect width={16} height={3} x={4} y={8} rx={1} />
		<path d="M12 10.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyGiftLight
